// TODO: Fix all linting warnings in layout-lib #36010
/* eslint-disable */
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'ml-async-result',
  templateUrl: './async-result.component.html',
  standalone: false,
})
export class AsyncResultComponent implements OnChanges, OnDestroy {
  @Input() operation: Observable<any>;
  @Input() hide = true;
  private _loading: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private subscription: Subscription;

  isEmpty = false;
  hasResult = false;
  isLoading: Observable<boolean> = this._loading.pipe(debounce((val) => (val ? timer(100) : timer(0))));

  constructor() {}

  ngOnChanges() {
    this.cleanUp();

    this._loading.next(true);
    this.subscription = this.operation.subscribe(
      (x) => this.loadCompleted(x),
      (error) => {},
      () => {
        this._loading.next(false);
      }
    );
  }

  loadCompleted(result: any) {
    this._loading.next(false);
    if (result && result instanceof Array) {
      this.hasResult = result.length > 0;
      this.isEmpty = result.length === 0;
    } else if (result) {
      this.hasResult = true;
      this.isEmpty = false;
    } else {
      this.hasResult = false;
      this.isEmpty = true;
    }
  }

  ngOnDestroy() {
    this.cleanUp();
  }

  private cleanUp(): void {
    // Cleanup previous subscription
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
